import { render, staticRenderFns } from "./Insumos.vue?vue&type=template&id=0ad83186&"
import script from "./Insumos.vue?vue&type=script&lang=js&"
export * from "./Insumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports